module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-content', [_c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', [_c('label', [_vm._v("请输入APPID/ID/产品名称")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.pdata.kw),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "kw", $$v)
      },
      expression: "pdata.kw"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', [_c('label', {
    attrs: {
      "for": "status"
    }
  }, [_vm._v("请选择广告状态")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "status",
      "id": "status"
    },
    model: {
      value: (_vm.pdata.status),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "status", $$v)
      },
      expression: "pdata.status"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "fight-club",
      "value": _vm.noText
    }
  }, [_vm._v("请选择广告状态")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "fight-club",
      "value": '1'
    }
  }, [_vm._v("启用")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "fight-club",
      "value": '0'
    }
  }, [_vm._v("禁用")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("请选择广告类型")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.pdata.type),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "type", $$v)
      },
      expression: "pdata.type"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "fight-club",
      "value": _vm.noText
    }
  }, [_vm._v("请选择广告类型")]), _vm._v(" "), _vm._l((_vm.config), function(item, index) {
    return _c('md-option', {
      attrs: {
        "value": "fight-club",
        "value": item[1]
      }
    }, [_vm._v(_vm._s(item[0]))])
  })], 2)], 1)], 1)]), _vm._v(" "), _c('md-content', [(_vm.plist.length > 0) ? _c('md-table', {
    on: {
      "md-selected": _vm.onSelect
    },
    scopedSlots: _vm._u([{
      key: "md-table-row",
      fn: function(ref) {
        var item = ref.item;

        return _c('md-table-row', {
          attrs: {
            "md-selectable": "multiple",
            "md-auto-select": ""
          }
        }, [_c('md-table-cell', {
          attrs: {
            "md-label": "ID",
            "md-sort-by": "id",
            "md-numeric": ""
          }
        }, [_vm._v(_vm._s(item.id))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "小程序名称",
            "md-sort-by": "name"
          }
        }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "广告位名称",
            "md-sort-by": "email"
          }
        }, [_vm._v(_vm._s(item.name + '-' + item.type_name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "广告位类型",
            "md-sort-by": "gender"
          }
        }, [_vm._v(_vm._s(item.type_name))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "广告位尺寸",
            "md-sort-by": "title"
          }
        }, [_vm._v(_vm._s(item.width + 'X' + item.height))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "支持设备",
            "md-sort-by": "title"
          }
        }, [_vm._v(_vm._s(item.device))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "启用时间",
            "md-sort-by": "title"
          }
        }, [_vm._v(_vm._s(item.create_time))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "禁用时间",
            "md-sort-by": "title"
          }
        }, [_vm._v(_vm._s(item.end_time))]), _vm._v(" "), _c('md-table-cell', {
          attrs: {
            "md-label": "广告位状态",
            "md-sort-by": "title"
          }
        }, [_vm._v(_vm._s(item.status == 1 ? '正常' : '禁用'))])], 1)
      }
    }], null, false, 4188794230),
    model: {
      value: (_vm.plist),
      callback: function($$v) {
        _vm.plist = $$v
      },
      expression: "plist"
    }
  }, [_c('md-table-toolbar', [_c('h1', {
    staticClass: "md-title"
  }, [_vm._v("广告位")]), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter"
  }, [_c('div', {
    staticClass: "md-layout-item md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-raised",
    nativeOn: {
      "click": function($event) {
        return _vm.addBanner($event)
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary"
  }, [_vm._v("启用")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-raised md-accent"
  }, [_vm._v("禁用")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-raised md-accent"
  }, [_vm._v("删除")])], 1)])])], 1) : _c('md-table', [_c('md-table-row', [_c('md-table-head', [_vm._v("暂无信息")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter md-alignment-center"
  }, [_c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-dense md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goPrev($event)
      }
    }
  }, [_vm._v("上一页")])], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-80 md-small-size-50 md-xsmall-size-50"
  }, [_c('md-field', [_c('label', [_vm._v("选择页码")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "page",
      "id": "page"
    },
    model: {
      value: (_vm.pdata.page),
      callback: function($$v) {
        _vm.$set(_vm.pdata, "page", $$v)
      },
      expression: "pdata.page"
    }
  }, _vm._l((_vm.maxPage), function(item) {
    return _c('md-option', {
      attrs: {
        "value": item
      }
    }, [_vm._v(_vm._s(item))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-25 md-xsmall-size-25"
  }, [_c('md-button', {
    staticClass: "md-dense md-primary",
    nativeOn: {
      "click": function($event) {
        return _vm.goNext($event)
      }
    }
  }, [_vm._v("下一页")])], 1)])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    attrs: {
      "md-active": _vm.editDialog
    },
    on: {
      "update:mdActive": function($event) {
        _vm.editDialog = $event
      },
      "update:md-active": function($event) {
        _vm.editDialog = $event
      }
    }
  }, [_c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateUser($event)
      }
    }
  }, [_c('md-content', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('md-dialog-title', [_vm._v(_vm._s(_vm.isAdd == true ? "新增广告位" : "编辑广告位"))]), _vm._v(" "), _c('div', {
    staticClass: "md-layout md-gutter md-alignment-center"
  }, [_c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('issued_app_id')
  }, [_c('label', {
    attrs: {
      "for": "issued_app_id"
    }
  }, [_vm._v("请选择小程序名称")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "issued_app_id",
      "id": "issued_app_id"
    },
    model: {
      value: (_vm.form.issued_app_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "issued_app_id", $$v)
      },
      expression: "form.issued_app_id"
    }
  }, _vm._l((_vm.applist), function(item, index) {
    return _c('md-option', {
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("请选择小程序名称")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('type')
  }, [_c('label', {
    attrs: {
      "for": "type"
    }
  }, [_vm._v("请选择广告位类型")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "type",
      "id": "type"
    },
    model: {
      value: (_vm.form.type),
      callback: function($$v) {
        _vm.$set(_vm.form, "type", $$v)
      },
      expression: "form.type"
    }
  }, _vm._l((_vm.config), function(item, index) {
    return _c('md-option', {
      attrs: {
        "value": item[1]
      }
    }, [_vm._v(_vm._s(item[0]) + "(" + _vm._s(item[1]) + ")")])
  }), 1), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("请选择广告位类型")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-medium-size-10 md-small-size-50 md-xsmall-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('device')
  }, [_c('label', {
    attrs: {
      "for": "device"
    }
  }, [_vm._v("广告系统")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "name": "device",
      "id": "device"
    },
    model: {
      value: (_vm.form.device),
      callback: function($$v) {
        _vm.$set(_vm.form, "device", $$v)
      },
      expression: "form.device"
    }
  }, [_c('md-option', {
    attrs: {
      "value": "all"
    }
  }, [_vm._v("all")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "ios"
    }
  }, [_vm._v("ios")]), _vm._v(" "), _c('md-option', {
    attrs: {
      "value": "android"
    }
  }, [_vm._v("android")])], 1), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("请选择广告系统")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "md-layout-item md-xsmall-size-100"
  }, [_c('md-field', {
    class: _vm.getValidationClass('width')
  }, [_c('label', [_vm._v("输入广告尺寸-宽度")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.width),
      callback: function($$v) {
        _vm.$set(_vm.form, "width", $$v)
      },
      expression: "form.width"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("请输入广告尺寸-宽度")])], 1), _vm._v(" "), _c('md-field', {
    class: _vm.getValidationClass('height')
  }, [_c('label', [_vm._v("输入广告尺寸-高度")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.form.height),
      callback: function($$v) {
        _vm.$set(_vm.form, "height", $$v)
      },
      expression: "form.height"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error"
  }, [_vm._v("输入广告尺寸-高度")])], 1)], 1)]), _vm._v(" "), (_vm.sending) ? _c('md-progress-bar', {
    attrs: {
      "md-mode": "indeterminate"
    }
  }) : _vm._e(), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.editDialog = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "type": "submit",
      "disabled": _vm.sending
    }
  }, [_vm._v("保存")])], 1)], 1)], 1)]), _vm._v(" "), _c('md-dialog-alert', {
    attrs: {
      "md-active": _vm.isSuc,
      "md-content": _vm.successMessage,
      "md-confirm-text": "知道了!"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.isSuc = $event
      },
      "update:md-active": function($event) {
        _vm.isSuc = $event
      }
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    attrs: {
      "md-active": _vm.isErr,
      "md-content": _vm.ErrorMessage,
      "md-confirm-text": "知道了!"
    },
    on: {
      "update:mdActive": function($event) {
        _vm.isErr = $event
      },
      "update:md-active": function($event) {
        _vm.isErr = $event
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/template-compiler?{"id":"data-v-aac55542"}!D:/发行部门文件/后台管理系统文件/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/ADbanner.vue
// module id = 529
// module chunks = 0